import { useMemo } from 'react';
import { Field } from 'formik';
import Select from '../../../../../../../../FormikFields/ComplexSelect/Select';
import { makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { setAccountBackendErrors } from '../../../../../../../../../redux_store';

const useStyles = makeStyles(() => ({
  selector: {
    width: '100%',
    height: 44,
    outline: 'transparent !important',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#dfe3e7',
      '&:hover': {
        borderColor: '#dfe3e7',
        outline: 'transparent !important',
      },
    },
    '&:hover': {
      outline: 'transparent !important',
    },
  },
  tableItem: {
    // padding: '8px 0',
    padding: '12px 0',
    display: 'flex',
    alignItems: 'start',
    height: '100%'
  },
}));

const styles = {
  activitiesErrorStyle: {
    position: 'absolute',
    marginLeft: 0,
    // bottom: 0,
    marginTop: 40,
  },
};

const CptCodeComponent = (props) => {
  const classes = useStyles();
  const {
    row: { index: i },
    cptCodes,
    updateFieldValue,
  } = props;
  const index = parseInt(i);
  const dispatch = useDispatch();
  const { backendErrors } = useSelector((state) => state.accountEditing);
  const setBackendErrors = (newErrors) => {
    dispatch(setAccountBackendErrors(newErrors));
  }
  const onDataChange = async (dataKey, value, field, form) => {
    await form.setFieldValue(`ispConfiguration.services[${index}].cptCode`, value);
    updateFieldValue(index, 'cptCode', value);
    if (backendErrors) {
      if (backendErrors[`ispConfiguration.services[${index}]`]) {
        const newBackendErrors = {...backendErrors}
        delete newBackendErrors[`ispConfiguration.services[${index}]`];
        setBackendErrors(newBackendErrors);
      } else if (backendErrors?.ispConfiguration?.services && backendErrors?.ispConfiguration?.services[index].cptCode) {
        const newErrors = {
          ...backendErrors,
          ispConfiguration: {
            ...backendErrors.ispConfiguration,
            services: backendErrors.ispConfiguration.services.map((service, i) => {
              if (i === index) {
                const newError = { ...service };
                delete newError?.cptCode;
                return newError;
              } else {
                return service;
              }
            }),
          },
        }
        if (!newErrors.ispConfiguration.services.length) {
          delete newErrors.ispConfiguration.services
        }
        setBackendErrors(newErrors);
      }
    }
  };

  const errors = useMemo(
    () => (backendErrors &&
      ((backendErrors?.ispConfiguration?.services &&
        backendErrors.ispConfiguration.services[index] &&
        backendErrors.ispConfiguration.services[index].cptCode) || backendErrors[`ispConfiguration.services[${index}]`])
    ),
    [backendErrors],
  );

  return <div className={classes.tableItem}>
    <Field type={'select'} name={`ispConfiguration.services[${index}].cptCode`}>
      {({ field, form }) => {
        const allExisted = cptCodes?.map(({ value }) => value) || [];
        const allSelected = form?.values?.ispConfiguration?.services?.map(({ cptCode }) => cptCode) || [];
        const disabledItems = allExisted?.filter(i => allSelected.includes(i));
        return <Select
          name={`ispConfiguration.services[${index}].cptCode`}
          required={true}
          dataKey="code"
          filterValue={field.value}
          disableUnderline
          placeholder={'CPT code'}
          autoComplete="off"
          InputProps={{
            classes: {
              root: classes.selector,
            },
          }}
          disabledItems={disabledItems}
          className={classes.selector}
          activitiesErrorStyle={styles.activitiesErrorStyle}
          columnData={{
            isFilterable: true,
            options: (cptCodes || []),
          }}
          onChange={(dataKey, value) => onDataChange(dataKey, value, field, form)}
          error={errors}
        />;
      }}
    </Field>
  </div>;
};

export default CptCodeComponent;

Object.defineProperties(Array.prototype, {
  count: {
    value: function(value) {
      return this.filter(x => x === value).length;
    },
  },
});
